import moment from 'moment';

/**
 * @description Returns Date format if the difference between the current time and input date is more than a day.
 * Otherwise returns Hours format.
 * @param {string} value - DateTime value
 * @return {string} DateTime format
 */
export const getDateTimeFormat = (value: string): string => {
    const date = moment(value);
    const currentDate = moment();
    return date.isSame(currentDate, 'day')
        ? 'h:mm a'
        : 'DD-MMM-YYYY';
};
